import React from "react";
import './Recent-Alerts.css';
import {Heading, Columns, Table} from 'react-bulma-components';
import {addDoc, collection, doc, GeoPoint, getDoc, getDocs, orderBy} from "firebase/firestore";
import {db} from "../firestore";


function AlertsBox(props) {

    let typeofalert = "all"
    if (props.type !== undefined) {
        typeofalert = props.type
    }

    console.log(typeofalert)

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    if (readCookie("Username") !== null) {
        console.log("Reading cookie for User now.")
        console.log(readCookie("Username"))
    }

    const setNewAlert = async () => {
        console.log("Setting new Data")
        const patientsRef = collection(db, "Alerts");
        var yesterday = new Date(new Date(). getTime() - (24 * 60 * 60 * 1000));
        await addDoc(collection(db, "Alerts"), {
            Address: "ABC Tower, Kamal Ataturk Ave, Dhaka 1200",
            DateTime: yesterday,
            AddressLoc: new GeoPoint(23.9191, 90.2901 ),    // API for Geopoint Location would go here.
            TypeofAlert: "Fire Alert"
        });
    }

    function timeConverter(UNIX_timestamp){
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var year = (a.getFullYear() - 1969);
        var month = months[a.getMonth()];
        var date = a.getDate();
        var hour = a.getHours();
        var min = a.getMinutes();
        var sec = a.getSeconds();
        return date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
    }

    // setNewAlert();

    const getAlerts = async () => {

        console.log('Getting Data')

        const querySnapshot = await getDocs(collection(db, "Alerts"), orderBy("Address", "desc"))
        return querySnapshot.forEach((doc) => {
            let table = document.getElementById('alerts');
            let row = document.createElement('tr');
            let cell1 = row.insertCell();
            cell1.textContent = timeConverter(doc.data()["DateTime"])
            let cell2 = row.insertCell();
            cell2.textContent = doc.data()["Address"]
            cell2.insertAdjacentHTML("beforeend", "<a>  ↓</a>")
            let cell3 = row.insertCell();
            cell3.textContent = doc.data()["TypeofAlert"]
            let cell4 = row.insertCell();
            cell4.innerHTML = '<Button color=\"danger\" size=\"small\" style="background-color: #d45757; border-color: white; color: white; padding-bottom: calc(0.5em - 2px); padding-left: 1em; padding-right: 1em; padding-top: calc(0.5em - 2px);">More Details</Button>'

            if (typeofalert !== "all") {
                if (typeofalert === doc.data()["TypeofAlert"]) {
                    table.appendChild(row);
                }
            } else {
                table.appendChild(row);
            }
        });

    };

    let userType

    const loadUserType = async () => {
        console.log("Loading User Type")
        const element = document.getElementById("alerts");

        if (readCookie("Username") !== null) {

            console.log("User is not null")

            const docRef = doc(db, "Users", readCookie("Username"));
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                console.log("Document data:", docSnap.data());
                userType = docSnap.data()["TypeofUser"]
                if (userType !== "NormalUser") {
                    await getAlerts()
                }
            } else {
                console.log("No such document!");
            }

            console.log("User Type:", userType);

            if (userType === "NormalUser") {
                element.style.display = 'None';
            }

        } else {
            console.log("User is null")
            element.style.display = 'None';

        }

    }

    loadUserType()

    return (
        <div className={"cardLayoutStyle"}>
            <Columns>
                <Columns.Column>
                    <Heading className={"has-text-centered"}>
                        Recent Alerts
                    </Heading>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table size="fullwidth">
                        <thead>
                        <tr>
                            <th>Date & Time</th>
                            <th>Address</th>
                            <th>Type of Alert</th>
                            <th>Alert Details</th>
                        </tr>
                        </thead>
                        <tbody id={"alerts"}>
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    );

}


export default AlertsBox;
